
/**
 * 보안 검증 상태 (진행 중, 통과, 실패)
 */
export type ProjectSaveResponseSecurityCheckStatus = typeof ProjectSaveResponseSecurityCheckStatus[keyof typeof ProjectSaveResponseSecurityCheckStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectSaveResponseSecurityCheckStatus = {
  pending: 'pending',
  passed: 'passed',
  failed: 'failed',
} as const;
